import { Component, OnInit, enableProdMode } from '@angular/core';
// import User from './services/user-auth/User';
import { UserService } from './services/user-auth/user.service';
import { PersonValidateService, IOptin } from './services/person-validate/person-validate.service';
// import { redirect } from './env/environment';

@Component({
    selector: 'dp-proof-of-life',
    templateUrl: './proof-of-life.component.html',
    styleUrls: ['./proof-of-life.component.scss']
})
export class ProofOfLifeComponent implements OnInit {
    public showLoadingArea = false;
    public showTracking = true;
    public error = false;
    public userData: any;
    public openOptin: IOptin = null;
    // public readonly redirect: Redirect = redirect;

    constructor(private userService: UserService, private personService: PersonValidateService) {}

    // constructor() {}
    public ngOnInit() {
        // this.userData = this.userService.getUserData();
        this.userData = {
            "id": '',
            "name": '',
            "fullName": '',
            
            "document": '',
            "email": '',
            "token": '',
            "picture": '',
            "birthdate": '',
            "phone": ''
        }
        this.checkStatus();

        window.scroll(0, 0);
    }

    public onSuccess() {
        this.showTracking = true;
    }

    public onError() {
        this.error = true;
    }

    public checkStatus() {
        this.showLoadingArea = true;

        this.personService.optinStatus().subscribe(
            (response: IOptin[]) => {
                this.openOptin = this.personService.getPendingOptin(response);
                this.showLoadingArea = false;
            },
            () => {
                this.showLoadingArea = false;
                this.error = true;
            }
        );
    }
}
